import { Route } from '@angular/router';
import { ContainerComponent } from './components/container/container.component';
import { CalculatorComponent } from './components/calculator/calculator.component';

export const tvoedSalaryCalculatorRoutes: Route[] = [
  { path: '', redirectTo: 'gehalt', pathMatch: 'full' },
  {
    path: 'gehalt',
    component: ContainerComponent,
    children: [
      { path: '', redirectTo: 'rechner', pathMatch: 'full' },
      { path: 'rechner', component: CalculatorComponent }
    ]
  }
];
